<swiper
  #swiper
  class="swiper-container"
  [class.loading]="isLoading"
  [slidesPerView]="'auto'"
  [direction]="swiperConfig.direction"
  [speed]="swiperConfig.speed"
  [loop]="swiperConfig.loop"
  [spaceBetween]="swiperConfig.spaceBetween"
  [autoplay]="swiperConfig.autoplay"
  [pagination]="swiperConfig.pagination === true ? { clickable: true } : false"
  [scrollbar]="swiperConfig.scrollbar === true ? { draggable: true } : false"
  [navigation]="{
    nextEl: '.swiper-button-next-' + uniqueId,
    prevEl: '.swiper-button-prev-' + uniqueId,
  }"
  (reachEnd)="onReachEnd()"
  [class.argo-align-start]="isFirstSlideLefterThanScreen"
  [class.tablet-styles]="hasTabletStyles"
  [enabled]="!disabled"
  class="show-last-slide-fully"
>
  @if (!hasIndex) {
    @for (slide of slides; track slide; let i = $index) {
      <ng-template swiperSlide>
        <ng-container *ngTemplateOutlet="template; context: { $implicit: slide }"></ng-container>
      </ng-template>
    }
  }

  @if (hasIndex) {
    @for (slide of slides; track slide; let i = $index) {
      <ng-template swiperSlide>
        <ng-container *ngTemplateOutlet="template; context: { $implicit: { slide: slide, index: i } }"></ng-container>
      </ng-template>
    }
  }
</swiper>

@if (swiperConfig.navigation) {
  <div
    class="swiper-button-prev-{{ uniqueId }} swiper-button-prev"
    [class.only-gradient]="hasOnlyGradient"
    [class.tablet-styles]="hasTabletStyles"
  ></div>

  <div
    class="swiper-button-next-{{ uniqueId }} swiper-button-next"
    [class.only-gradient]="hasOnlyGradient"
    [class.loading]="isLoading"
    [class.has-next-slides]="totalSlides > slides.length"
    [class.tablet-styles]="hasTabletStyles"
  ></div>
}
